export const TABLE_OPTIONS = {
  paging: false,
  search: true,
  searchFieldAlignment: 'right',
  searchFieldVariant: 'outlined',
  searchText: '',
  toolbar: true,
  showTitle: true,
  showFirstLastPageButtons: false,
  showSelectAllCheckbox: false,
  showTextRowsSelected: false,
  toolbarButtonAlignment: 'left',
  searchFieldStyle: { width: '410px' }
} as const; 